import { classNames as cn, IsBoolChoice, IsInline } from 'helpers';
import { type QuestionProps, QuestionType } from 'types';
import { Choices } from './Choices';
import { Question } from './Question';
import { QuestionDropdown } from './QuestionDropdown';

export function QuestionContent(props: QuestionProps) {
	const { choices, isSubquestion = false, questionType, subQuestions, testId } = props;
	const isBoolChoice = IsBoolChoice(choices);
	const inline = IsInline(choices);
	const isDropdown = isSubquestion && !isBoolChoice && QuestionType.RadioMatrix === questionType;
	return (
		<div className={cn({ inline, row: !inline, 'text-start': isBoolChoice })}>
			{isDropdown ? (
				<QuestionDropdown {...props} />
			) : (
				<>
					<Choices {...props} />
					{subQuestions.map(q => (
						<Question {...q} isSubquestion key={q.id} testId={testId} />
					))}
				</>
			)}
		</div>
	);
}
